import { createContext, useCallback, useContext, useState } from 'react'

interface ServerStatusContextType {
    isServerAvailable: boolean
    isChecking: boolean
    setServerAvailable: (available: boolean) => void
    setChecking: (checking: boolean) => void
}

const ServerStatusContext = createContext<ServerStatusContextType>({
    isServerAvailable: true,
    isChecking: false,
    setServerAvailable: () => {},
    setChecking: () => {},
})

export function useServerStatus() {
    return useContext(ServerStatusContext)
}

export function ServerStatusProvider({ children }: { children: React.ReactNode }) {
    const [isServerAvailable, setServerAvailableState] = useState(true)
    const [isChecking, setIsChecking] = useState(false)

    const setServerAvailable = useCallback((available: boolean) => {
        setServerAvailableState(available)
    }, [])

    const setChecking = useCallback((checking: boolean) => {
        setIsChecking(checking)
    }, [])

    return (
        <ServerStatusContext.Provider value={{ isServerAvailable, isChecking, setServerAvailable, setChecking }}>
            {children}
        </ServerStatusContext.Provider>
    )
}
